import gql from "graphql-tag";
const getuserActivityQuery = gql(` 
query userActivity($event: AWSJSON!) {
  userActivity(event: $event) {
    result
    error
  }
}
`)
export default getuserActivityQuery;
